import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { carStatistic } from '../utilits/statisticTools'

export default function CarStatistic() {
  return (
    <div className='carStatistic'>
        <h3><span>Car</span> Statistics</h3>
        <ReactApexChart options={carStatistic.options} series={carStatistic.series} type="area" height={350} />
    </div>
  )
}
